<template>
    <plugin-home-how-it-works-v2-base-item v-bind:item="item">
        <div class="plugin-home-how-it-works-item__image">
            <img v-bind:src="item.image" alt="" />
        </div>
    </plugin-home-how-it-works-v2-base-item>
</template>

<script>
export default {
    name: 'plugin-home-how-it-works-v2-item',
    props: {
        item: {
            type: Object,
        },
    },
    data: () => ({

    }),
    methods: {

    },
    mounted() {

    },
    beforeDestroy() {

    },
};
</script>

<style scoped lang="less">
@import '~theme';

.plugin-home-how-it-works-item {
    &__image {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;

        width: 100%;
        height: 100%;
        padding: 55px;

        background-color: #311457;

        aspect-ratio: 1 / 1;

        img {
            width: 100%;
            max-width: 350px;
            // aspect-ratio: 1 / 1;
        }
    }
    @media @media-md-down {
        &__image {
            width: 100%;
            padding: 24px;
            img {
                width: 100%;
            }
        }
    }
}
</style>
